import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ageRangeListing, emiratesListing, teachingInfoListing } from "../apis/apiHandler";

export const ageRangeList = createAsyncThunk(
    'all_lists/age_range',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await ageRangeListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const teachingInfoList = createAsyncThunk(
    'all_lists/teaching_info',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await teachingInfoListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const emiratesList = createAsyncThunk(
    'all_lists/emirates',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await emiratesListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    ageRangeLists: [],
    teachingInfoLists: [],
    emiratesLists: [],
    error: null,
};

const allListsSlice = createSlice({
    name: 'all_lists',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(ageRangeList.pending, (state) => {
                state.loading = true;
            })
            .addCase(ageRangeList.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.ageRangeLists = payload?.data;
            })
            .addCase(ageRangeList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(teachingInfoList.pending, (state) => {
                state.loading = true;
            })
            .addCase(teachingInfoList.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.teachingInfoLists = payload?.data;
            })
            .addCase(teachingInfoList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(emiratesList.pending, (state) => {
                state.loading = true;
            })
            .addCase(emiratesList.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.emiratesLists = payload?.data;
            })
            .addCase(emiratesList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})

export default allListsSlice.reducer;